import { ApplicantInterviewers } from '@app/models/recruiting/applicant-interviewers.model';
import { InterviewsStatus } from '@app/modules/applicant-tracker/enums/interview-status.enum';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Translatable } from '@app/types/translatable.type';
import { InterviewStatusDisplayOptions } from '@app/types/translatables/interview-status-display.options';

export class Status extends Column {
    title = 'applicant-tracker.status';
    property = 'status';
    sortable = true;
    type: CellDisplay = CellDisplay.string;

    getRowStyling(applicantInterviewer: ApplicantInterviewers): { [key: string]: string } {
        if (applicantInterviewer.status === InterviewsStatus.Overdue) {
            return { color: 'var(--error-800)' };
        }

        if (applicantInterviewer.status === InterviewsStatus.Pending) {
            return { color: 'var(--success-500)' };
        }

        return;
    }

    getDisplayPropertyValue(applicantInterviewer: ApplicantInterviewers): Translatable {
        return InterviewStatusDisplayOptions[applicantInterviewer.status] ?? applicantInterviewer.status;
    }
}
